import { ErrorResponseErrorItemCodeDongle } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeDongle, string> = {
  'dongle:already_registered': 'Dongeln är redan registrerad till ett projekt.',
  'dongle:id_exists': 'Dongeln existerar redan.',
  'dongle:not_found': 'Dongeln existerar inte.',
  'dongle:authentication_failed': 'Det gick inte att autentisera dongeln.',
  'dongle:not_registered': 'Dongeln är inte registrerad till ett projekt.',
  'dongle:not_active': 'Dongeln är inte aktiv.',
};
